import { Type } from '@sinclair/typebox';

export const NoteValidationSchema = Type.Union([
  Type.Null(),
  Type.String({
    pattern: '^[A-Za-z0-9ÉØ&/*;\'≥:,%"#~+\\-\\[\\]\\\\@—^.!$(){}|_ ]*$',
  })
]);